import {CookbookContext} from "./CookbookContext";
import {PathwayContext} from "./PathwayContext";
import {Dispatch} from "react";
import {ConcreteContext} from "./ConcreteContext";
import {IFirebaseContext} from "./IFirebaseContext";
import {Database, getDatabase, push as firebasePush, ref} from "@firebase/database";

export class FirebaseContext implements IFirebaseContext {
    private readonly cookbookContext: ConcreteContext;
    private readonly pathwayContext: ConcreteContext;
    private readonly database: Database;

    private context: ConcreteContext;
   
    constructor(dispatch: Dispatch<any>, user: string) {
        this.database = getDatabase();
        this.cookbookContext = new CookbookContext(dispatch, user);
        this.pathwayContext = new PathwayContext(dispatch);
        this.context = this.pathwayContext;
    }
    setSource = (provider: ("pathway" | "cookbook")) => {
        if (provider === "cookbook") {
            this.context = this.cookbookContext;
        } else {
            this.context = this.pathwayContext;
        }
    }
    setScript = (project: string, state: string, previous: string, update: string, user: string, replace: string[] = []) => {
        return this.context.setStateMember(project, state, "script", update).then(() =>
            firebasePush(ref(this.database, `versions/${project}/script/${state}`), {
                date: Date.now(),
                user,
                script: previous
            })
        );
    }

    get = (path: string) => this.context.get(path);
    getScriptVersions = (project: string, state: string) => this.context.getScriptVersions(project, state);
    getUser = (userKey: string) => this.context.getUser(userKey);
    push = (path: string, value: unknown) => this.context.push(path, value);
    pushComment = (project: string, value: unknown) => this.context.pushComment(project, value);
    pushCommentReply = (project: string, comment: string, value: unknown) =>
        this.context.pushCommentReply(project, comment, value);
    pushIgnoreGrammar = (project: string, state: string, value: unknown) =>
        this.context.pushIgnoreGrammar(project, state, value);
    pushNotification = (user: string, details: unknown) =>
        this.context.pushNotification(user, details);
    pushState = (project: string, value: unknown) => this.context.pushState(project, value);
    last = (path: string, count: number) => this.context.last(path, count);
    remove = (path: string) => this.context.remove(path);
    removeInvite = (invite: string) => this.context.removeInvite(invite);
    removeLock = (project: string, state: string) => this.context.removeLock(project, state);
    removeNetwork = (project: string) => this.context.removeNetwork(project);
    removeRegister = (project: string, register: string) => this.context.removeRegister(project, register);
    removeState = (project: string, state: string) => this.context.removeState(project, state);
    set = (path: string, value: unknown) => this.context.set(path, value);
    setCommentMember = (project: string, commentId: string, member: unknown, value: unknown) =>
        this.context.setCommentMember(project, commentId, member, value);
    setCommentReplyMember = (project: string, commentId: string, reply: string, member: unknown, value: unknown) =>
        this.context.setCommentReplyMember(project, commentId, reply, member, value);
    setDictionaryEntry = (project: string, user: string, value: string) =>
        this.context.setDictionaryEntry(project, user, value);
    setGrammar = (project: string, state: string, value: unknown) => this.context.setGrammar(project, state, value);
    setLock = (project: string, state: string, user: string) => this.context.setLock(project, state, user);
    setNetworkMember = (project: string, member: string, value: unknown) =>
        this.context.setNetworkMember(project, member, value);
    setProjectMember = (project: string, member: string, value: unknown) =>
        this.context.setProjectMember(project, member, value);
    setRegister = (project: string, register: string, value: unknown) =>
        this.context.setRegister(project, register, value);
    setStateMember = (project: string, state: string, member: string, value: unknown) =>
        this.context.setStateMember(project, state, member, value);
    setStatePosition = (project: string, state: string, value: unknown) => 
        this.context.setStatePosition(project, state, value);
    setStateTransitionMember = (project: string, state: string, transition: number, member: string, value: unknown) =>
        this.context.setStateTransitionMember(project, state, transition, member, value);
    setUserMember = (user: string, member: string, value: unknown) => this.context.setUserMember(user, member, value);
    track = (path: string, store?: string[]) => this.context.track(path, store);
    trackComments = (project: string) => this.context.trackComments(project);
    trackDictionary = (project: string) => this.context.trackDictionary(project);
    trackGrammar = (network: string) => this.context.trackGrammar(network);
    trackSheets = (project: string) => this.context.trackSheets(project);
    trackIgnoredGrammar = (network: string) => this.context.trackIgnoredGrammar(network);
    trackInvites = () => this.context.trackInvites();
    trackNetwork = (network: string, filter = false) => this.context.trackNetwork(network, filter);
    trackUser = (user: string) => this.context.trackUser(user);
    trackUsers = () => this.context.trackUsers();
    untrack = (path: string) => this.context.untrack(path);
    untrackNetwork = (network: string) => this.context.untrackNetwork(network);
    untrackUser = (user: string) => this.context.untrackUser(user);
}